var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-center"},[_c('p',{staticClass:"h2"},[_vm._v(_vm._s(_vm.mensajeValidacion))])])}
var staticRenderFns = []

export { render, staticRenderFns }